var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.directionsOfUse)?_c('div',{staticClass:"directions-of-use"},[_c('summary-direction-of-use-tab',{staticClass:"directions-of-use__summary",attrs:{"directions-of-use":_vm.directionsOfUse}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }